import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDeviceMap } from '@/api/routes/devices/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchDevicesMap } from './actionCreators';

interface InitialState {
  devicesMap: IDeviceMap [],
  isLoading: boolean,
  offset: number,
  totalCount: number,
  error: string,
}

const initialState: InitialState = {
  devicesMap: [],
  offset: 0,
  totalCount: 0,
  isLoading: false,
  error: '',
};

export const devicesMapSlice = createSlice({
  name: 'devicesMap',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDevicesMap.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<IDeviceMap>>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesMap = action.payload.rows;
      state.offset = action.payload.offset;
      state.totalCount = action.payload.total_count;
    },
    [fetchDevicesMap.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesMap.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default devicesMapSlice.reducer;
